// eslint-disable-next-line import/no-anonymous-default-export
export default (state, action) => {
  switch (action.type) {
    case "atual-plate":
      return {
        ...state,
        atualPlate: action.payload
      };
    case "atual-applet-profile-id":
      return {
        ...state,
        atualAppletProfileId: action.payload
      };
    case "atual-unique-id":
      return {
        ...state,
        atualUniqueID: action.payload
      };
    case "applet-to-edit":
      return {
        ...state,
        appletToEdit: action.payload
      };
    case "atual-vehicle-data":
      return {
        ...state,
        atualVehicleData: action.payload
      };
    default:
      return state;
  }
};
